/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdUsers202,
  PostApiV1ClassroomdisciplineIdUsers400,
  PostApiV1ClassroomdisciplineIdUsers401,
  PostApiV1ClassroomdisciplineIdUsers404,
  PostApiV1ClassroomdisciplineIdUsersMutationRequest,
  PostApiV1ClassroomdisciplineIdUsersMutationResponse,
  PostApiV1ClassroomdisciplineIdUsersPathParams,
} from "../../types/classPlanningPeopleController/PostApiV1ClassroomdisciplineIdUsers.ts";
import { insertClassroomUserRequestViewModelSchema } from "../insertClassroomUserRequestViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdUsersPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsersPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdUsers202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsers202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdUsers400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsers400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdUsers401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsers401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdUsers404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsers404>;

export const postApiV1ClassroomdisciplineIdUsersMutationRequestSchema = z.lazy(
  () => insertClassroomUserRequestViewModelSchema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsersMutationRequest>;

export const postApiV1ClassroomdisciplineIdUsersMutationResponseSchema = z.lazy(
  () => postApiV1ClassroomdisciplineIdUsers202Schema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineIdUsersMutationResponse>;
